import { TYPES } from '../actions';

const initialState = {
  users: [],
  loading: false,
  error: null
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ACTION_GET_USERS_LOADING:
    case TYPES.ACTION_SET_USERS_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };
    case TYPES.ACTION_GET_USERS_SUCCESS:
    case TYPES.ACTION_SET_USERS_SUCCESS:
      return {
        ...state,
        users: action.payload.data?.users || action.payload.data || [],
        loading: false,
        error: null
      };
    case TYPES.ACTION_GET_USERS_FAIL:
    case TYPES.ACTION_SET_USERS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}; 